export const APPLET_Id = 'wx264f4850dc92b03d'
export const MEDIA_SHOW = false // 多模态商品展示 开启则代表不进行调试 开发测试用 上线请关闭设置为false
export const MINIMAX_HOST = 'https://api.minimax.chat'

// 线上环境
export const isDt = true // 改为标识
/*
export const STATIC_HOST = 'https://dt.aigcpop.com/api/'
export const APPLET_HOST = 'https://dt.aigcpop.com/applet/'
export const SHOP_HOST = 'https://h5.meuagi.com/package-prod/pages/prod/prod?prodId='
*/

// 测试/开发环境
/* export const STATIC_HOST = 'https://test.aigcpop.com/api/'
export const APPLET_HOST = 'https://test.aigcpop.com/applet/'
export const SHOP_HOST = 'https://h5.meuagi.com/package-prod/pages/prod/prod?prodId=' */


export const STATIC_HOST = isDt ? 'https://dt.aigcpop.com/api/' : 'https://test.aigcpop.com/api/'
export const APPLET_HOST = isDt ? 'https://dt.aigcpop.com/applet/' : 'https://test.aigcpop.com/applet/'
export const SHOP_HOST = isDt ? 'https://h5.meuagi.com/package-prod/pages/prod/prod?prodId=' : 'https://h5.meuagi.com/package-prod/pages/prod/prod?prodId='
